module.exports = __webpack_public_path__ + "img/fig14.7ec17ffc.jpg";